module.exports = __webpack_public_path__ + "img/arqu-cabc-06.4c3321cc.jpg";